"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var breakpoints = exports.breakpoints = {
  xs: 414,
  sm: 768,
  md: 992,
  lg: 1200
};


//////////////////
// WEBPACK FOOTER
// ./js/global/breakpoints.js
// module id = ./js/global/breakpoints.js
// module chunks = 0